<template>
    <div>
        <draggable :list="fields" :options="{handle: '.js-draggable-handle'}">
            <div v-for="(field, index) in fields">
                <div class="form-row mb-2">
                    <div class="d-flex align-items-center">
                        <i class="fas fa-ellipsis-v draggable-handle js-draggable-handle"></i>
                    </div>

                    <div class="col">
                        <input
                            v-model="field.name"
                            :name="`${prefix}[${index}][name]`"
                            class="form-control"
                            type="text"
                            placeholder="name"
                            required
                        >
                    </div>

                    <div class="col">
                        <select
                            v-model="field.type"
                            :name="`${prefix}[${index}][type]`"
                            class="custom-select"
                        >
                            <option value="text">text</option>
                            <option value="textarea">textarea</option>
                            <option value="email">email</option>
                            <option value="checkbox">checkbox</option>
                            <option value="radio">radio</option>
                            <option value="select">select</option>
                            <option value="tel">tel</option>
                            <option value="date">date</option>
                        </select>
                    </div>

                    <div class="col">
                        <textarea
                            v-model="field.options"
                            :name="`${prefix}[${index}][options]`"
                            class="form-control"
                            type="text"
                            placeholder="options"
                        >
                        </textarea>
                    </div>

                    <div class="col d-flex flex-column justify-content-center">
                        <div class="form-check">
                            <input
                                v-model="field.validationRules"
                                :name="`${prefix}[${index}][validationRules]`"
                                class="form-check-input"
                                type="checkbox"
                            >
                            <label :for="`${prefix}[${index}][validationRules]`" class="form-check-label">
                                required
                            </label>
                        </div>
                    </div>

                    <div class="col text-right">
                        <button class="btn btn-danger" @click="removeField(index)" type="button">
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </div>
                </div>
            </div>
        </draggable>

        <button class="btn btn-secondary" @click="addField" type="button">
            Veld toevoegen
        </button>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        components: { draggable },
        props: ['props'],

        data() {
            return {
                prefix: this.props.prefix,
                prefilledFields: this.props.prefilledFields,
                fields: JSON.parse(this.props.fields),
            };
        },

        created() {
            if (typeof this.prefilledFields !== 'undefined') {
                this.prefilledFields.split(',').forEach((name) => {
                    this.fields.push({
                        name,
                        type: 'text',
                        validationRules: 'required',
                    });
                });
            }
        },

        methods: {
            addField() {
                this.fields.push({
                    name: '',
                    type: 'text',
                    validationRules: 'required',
                });
            },

            removeField(index) {
                this.$delete(this.fields, index);
            },
        },
    };
</script>

<style scoped>
    textarea.form-control {
        height: calc(2.5125rem + 2px);
        min-height: calc(2.5125rem + 2px);
    }

    .draggable-handle {
        color: #c1c1c1;
        padding: 0 5px;
        font-size: 1.25rem;
    }

    .draggable-handle:hover {
        cursor: move;
    }
</style>
